import axios from 'axios';
import qs from 'qs';
import { DeviceModel } from '@/features/models/models.dto';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';
import { ClientDto } from '../client-admins/clients.dto';
import { ClientAdminUserDto, UserDto } from '../users/users.dto';
import {
	ClientsUsersByCompanyParams,
	ClientUsersByCompanyFilterType,
	CompanyDto,
	CompanyResponseDto,
} from './companies.dto';

interface ICompany {
	update: (id: number, payload: Partial<CompanyDto>, userId: number) => Promise<CompanyDto>;
	getAllCompanies: () => Promise<ServiceResponse<CompanyResponseDto[]>>;
	updateClient: (id: number, clientId: number, payload: Partial<ClientDto>, userId: number) => Promise<ClientDto>;
	createClient: (id: number, payload: Partial<ClientDto>, user: ClientAdminUserDto) => Promise<ClientDto>;
	getAllClientAdmins: (id: number, clientId: number) => Promise<ServiceResponse<UserDto[]>>;
	getClientUsers: (params: ClientsUsersByCompanyParams) => Promise<ServiceResponse<UserDto[]>>;
	getCompanyModels: (id: number) => Promise<DeviceModel[]>;
	deleteClientById: (companyId: number, clientId: number) => Promise<ServiceResponse>;
}

class Service implements ICompany {
	async update(id: number, payload: Partial<CompanyDto>, userId: number): Promise<CompanyDto> {
		const { data } = await axios.patch<CompanyDto>(`/v2/companies/${id}`, { payload, userId });
		return data;
	}

	getAllCompanies = async (): Promise<ServiceResponse<CompanyResponseDto[]>> => {
		const { data } = await axios.get<ServiceResponse<CompanyResponseDto[]>>('/v2/companies/all');
		return data;
	};
	updateClient = async (
		id: number,
		clientId: number,
		payload: Partial<ClientDto>,
		userId: number
	): Promise<ClientDto> => {
		const { data } = await axios.patch<ClientDto>(`/v2/companies/${id}/clients/${clientId}`, { payload, userId });
		return data;
	};
	getClientUsers = async ({
		id,
		clientId,
		search,
		filterType,
	}: ClientsUsersByCompanyParams): Promise<ServiceResponse<UserDto[]>> => {
		const params = { search, filterType };
		const { data } = await axios.get<ServiceResponse<UserDto[]>>(
			`/v2/companies/${id}/clients/${clientId}/users?${qs.stringify(params)}`
		);
		return data;
	};

	getAllClientAdmins = async (id: number, clientId: number): Promise<ServiceResponse<UserDto[]>> =>
		await this.getClientUsers({ id, clientId, filterType: ClientUsersByCompanyFilterType.CLIENT_ADMIN_USERS });

	async createClient(id: number, client: Partial<ClientDto>, user: ClientAdminUserDto): Promise<ClientDto> {
		const { data } = await axios.post<ClientDto>(`/v2/companies/${id}/clients`, { client, user });
		return data;
	}

	async getCompanyModels(id: number): Promise<DeviceModel[]> {
		const { data } = await axios.get<DeviceModel[]>(`/v2/companies/${id}/device-models`);
		return data;
	}

	async deleteClientById(companyId: number, clientId: number): Promise<ServiceResponse> {
		const { data } = await axios.delete<ServiceResponse>(`/v2/companies/${companyId}/clients/${clientId}`);
		return data;
	}
}

const CompanyService = new Service();

export default CompanyService;
